(function(root){
  'use strict';
  const normalizeId=value=>String(value||'').split('/').pop();
  const resolveVariant=(variants,id)=>variants.find(v=>normalizeId(v.id)===normalizeId(id))||null;
  const groupFor=(variant,catalog)=>catalog.find(row=>row.sku===variant.sku)?.group||'other';
  const galleryFor=(variant,catalog,fallback)=>{
    const row=catalog.find(item=>item.sku===variant.sku);
    if(row?.images?.length)return row.images.map(image=>({src:image.source||image.src,alt:image.alt||variant.title,type:'image'}));
    const image=variant.featured_image||variant.image;
    if(image)return[{src:image.src||image.url,alt:image.alt||variant.title,type:'image'}];
    return fallback||[];
  };
  const validQuantity=value=>Number.isFinite(Number(value))?Math.max(1,Math.min(99,Math.floor(Number(value)))):1;
  const formatMoney=(cents,currency='USD',locale='en-US')=>new Intl.NumberFormat(locale,{style:'currency',currency}).format(Number(cents)/100);
  const nextImage=(index,delta,length)=>length?(index+delta+length)%length:0;
  root.EnergyenerCore={normalizeId,resolveVariant,groupFor,galleryFor,validQuantity,formatMoney,nextImage};
})(typeof window==='undefined'?globalThis:window);
